import React, { Component } from "react";
import { Provider } from "react-redux";
import { NavBar, navBarSelectors, navBarConstants, NavItem } from "@fpos/react-navigation";
import axios from "axios";
import { Route } from "react-router-dom";
import { getInitialData } from "../store/main/mainActions";

import "./App.scss";
import "@fpos/react-navigation/lib/fpos-react-navigation.css";
import "@fpos/react-controls/lib/fpos-react-controls.css";

const homeNavItem = {
    type: navBarConstants.constNavigateWindow,
    path: "/"
};

class App extends Component {

    componentDidMount() {
    }

    canEditUsers = (userClaims) => {
        if (userClaims && (userClaims["canManageUsers"])){
            return true;
        }
        return false;
    }

    render() {
        const { store } = this.props;

        const onUserAuthStatusChanged = (status, callback) =>{
            if (status === navBarConstants.constUserLoggedIn){
                axios.defaults.headers.common["Authorization"] = "Bearer " + navBarSelectors.user(store.getState()).access_token;
                store.dispatch(getInitialData());
            }
            else
            {
                axios.defaults.headers.common["Authorization"] = "";
            }

            if (callback && callback instanceof Function) {
                callback();
            }
        };

        var navLeftItems = [];
        const link = {
            label: "User Managment",
            iconName: "user-edit-2",
            isAuthorized: this.canEditUsers,
            content: {
                text: "User Management"
            },
            action: {
                nav: {
                    type: navBarConstants.constNavigateWindow,
                    path: "/UserManagement"
                }
            }
        };

        navLeftItems.push(<NavItem navItemProps={link} key="Counter" />);

        return (
            <Provider store={store}>
                <div>
                    <NavBar store={store} title="Future Accounts" onUserAuthStatusChanged={onUserAuthStatusChanged} NavLeft={navLeftItems} logoNavAction={homeNavItem} >
                    </NavBar>
                </div>
            </Provider>
        );
    }
}

export default App;